import type { State } from '../../interfaces/State';
import type { LearningRecapState } from '../reducers/learningRecap';

export const selectLearningRecap = (state: State): LearningRecapState =>
  state.get('learningRecap');
